import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", testid }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
      data-testid={testid}
    >
      {children}
    </motion.div>
  );
}
